module.exports = __webpack_public_path__ + "img/pc1.4da53981.png";